(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8455],{

/***/ 19148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomHead; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


function CustomHead(_ref) {
  var children = _ref.children,
      title = _ref.title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("title", {
      children: [title, " | ", "SUPERMARKET Κρητικός"]
    }), children]
  });
}

/***/ }),

/***/ 84028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ contact_us; }
});

// EXTERNAL MODULE: ./styles/pages/index.module.scss
var index_module = __webpack_require__(28833);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./node_modules/react-icons/im/index.esm.js
var im_index_esm = __webpack_require__(53990);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./src/utils/googleAPIKey.js
var googleAPIKey = __webpack_require__(21694);
// EXTERNAL MODULE: ./src/components/CustomHead.jsx
var CustomHead = __webpack_require__(19148);
// EXTERNAL MODULE: ./src/components/EmailForm/EmailForm.jsx + 2 modules
var EmailForm = __webpack_require__(76011);
// EXTERNAL MODULE: ./src/components/Page Title/PageTitle.jsx
var PageTitle = __webpack_require__(36593);
// EXTERNAL MODULE: ./src/components/ContactLayout/ContactLayout.module.scss
var ContactLayout_module = __webpack_require__(23592);
var ContactLayout_module_default = /*#__PURE__*/__webpack_require__.n(ContactLayout_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/ContactLayout/ContactLayout.jsx











function ContactLayout(_ref) {
  var _contactInfo$fields, _contactInfo$fields2, _contactInfo$fields3, _contactInfo$fields4, _contactInfo$fields5, _contactInfo$fields6, _contactInfo$fields7, _contactInfo$fields8, _contactInfo$fields9, _contactInfo$fields10, _contactInfo$fields11, _contactInfo$fields12, _contactInfo$fields13;

  var contactInfo = _ref.contactInfo;
  var title = contactInfo === null || contactInfo === void 0 ? void 0 : (_contactInfo$fields = contactInfo.fields) === null || _contactInfo$fields === void 0 ? void 0 : _contactInfo$fields.contactTitle;
  var sections = contactInfo === null || contactInfo === void 0 ? void 0 : (_contactInfo$fields2 = contactInfo.fields) === null || _contactInfo$fields2 === void 0 ? void 0 : _contactInfo$fields2.section;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CustomHead/* default */.Z, {
      title: "\u0395\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03CE\u03BD\u03B7\u03C3\u03B5 \u03BC\u03B1\u03B6\u03AF \u03BC\u03B1\u03C2"
    }, "title"), /*#__PURE__*/(0,jsx_runtime.jsx)(PageTitle/* default */.Z, {
      title: "\u0395\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03CE\u03BD\u03B7\u03C3\u03B5 \u03BC\u03B1\u03B6\u03AF \u03BC\u03B1\u03C2",
      heading: "Contact Us"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: (ContactLayout_module_default()).container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ContactLayout_module_default()).contactContainer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: (ContactLayout_module_default()).heading,
          children: title
        }), sections === null || sections === void 0 ? void 0 : sections.map(function (section) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (ContactLayout_module_default()).row,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (ContactLayout_module_default()).rowContent,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (ContactLayout_module_default()).rowContentColumn,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: (ContactLayout_module_default()).contactTitle,
                  children: section.addressTitle
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: (ContactLayout_module_default()).contactText,
                  children: section.address
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (ContactLayout_module_default()).rowContent,
              children: [(section === null || section === void 0 ? void 0 : section.phoneNumber) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (ContactLayout_module_default()).rowContentColumn,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                  className: (ContactLayout_module_default()).contactTitle,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(im_index_esm/* ImPhone */.MdO, {
                    className: (ContactLayout_module_default()).icon,
                    alt: "phone icon"
                  }), section === null || section === void 0 ? void 0 : section.phoneTitle]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: (ContactLayout_module_default()).contactText,
                  children: section.phoneNumber
                })]
              }), (section === null || section === void 0 ? void 0 : section.faxNumber) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (ContactLayout_module_default()).rowContentColumn,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                  className: (ContactLayout_module_default()).contactTitle,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* AiFillPrinter */.s4T, {
                    className: (ContactLayout_module_default()).icon,
                    alt: "printer"
                  }), section === null || section === void 0 ? void 0 : section.faxTitle]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: (ContactLayout_module_default()).contactText,
                  children: section.faxNumber
                })]
              }), (section === null || section === void 0 ? void 0 : section.email) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (ContactLayout_module_default()).rowContentColumn,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                  className: (ContactLayout_module_default()).contactTitle,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdEmail */.ixJ, {
                    className: (ContactLayout_module_default()).icon,
                    alt: "email"
                  }), section === null || section === void 0 ? void 0 : section.emailTitle]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: (ContactLayout_module_default()).contactText,
                  children: section.email
                })]
              })]
            })]
          });
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (ContactLayout_module_default()).row,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (ContactLayout_module_default()).rowContent,
            children: (contactInfo === null || contactInfo === void 0 ? void 0 : (_contactInfo$fields3 = contactInfo.fields) === null || _contactInfo$fields3 === void 0 ? void 0 : _contactInfo$fields3.schedule) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (ContactLayout_module_default()).rowContentColumn,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: (ContactLayout_module_default()).contactTitle,
                children: contactInfo === null || contactInfo === void 0 ? void 0 : (_contactInfo$fields4 = contactInfo.fields) === null || _contactInfo$fields4 === void 0 ? void 0 : _contactInfo$fields4.scheduleTitle
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: (ContactLayout_module_default()).contactText,
                children: contactInfo === null || contactInfo === void 0 ? void 0 : (_contactInfo$fields5 = contactInfo.fields) === null || _contactInfo$fields5 === void 0 ? void 0 : _contactInfo$fields5.schedule
              })]
            })
          }), (contactInfo === null || contactInfo === void 0 ? void 0 : (_contactInfo$fields6 = contactInfo.fields) === null || _contactInfo$fields6 === void 0 ? void 0 : _contactInfo$fields6.phoneforcustomers) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (ContactLayout_module_default()).rowContent,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (ContactLayout_module_default()).rowContentColumn,
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                className: (ContactLayout_module_default()).contactTitle,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(im_index_esm/* ImPhone */.MdO, {
                  className: (ContactLayout_module_default()).icon,
                  alt: "phone icon"
                }), contactInfo === null || contactInfo === void 0 ? void 0 : (_contactInfo$fields7 = contactInfo.fields) === null || _contactInfo$fields7 === void 0 ? void 0 : _contactInfo$fields7.customerPhone]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: (ContactLayout_module_default()).contactText,
                children: contactInfo === null || contactInfo === void 0 ? void 0 : (_contactInfo$fields8 = contactInfo.fields) === null || _contactInfo$fields8 === void 0 ? void 0 : _contactInfo$fields8.phoneforcustomers
              })]
            })
          }), (contactInfo === null || contactInfo === void 0 ? void 0 : (_contactInfo$fields9 = contactInfo.fields) === null || _contactInfo$fields9 === void 0 ? void 0 : _contactInfo$fields9.emailForCustomers) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (ContactLayout_module_default()).rowContent,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (ContactLayout_module_default()).rowContentColumn,
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                className: (ContactLayout_module_default()).contactTitle,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdEmail */.ixJ, {
                  className: (ContactLayout_module_default()).icon,
                  alt: "email"
                }), contactInfo === null || contactInfo === void 0 ? void 0 : (_contactInfo$fields10 = contactInfo.fields) === null || _contactInfo$fields10 === void 0 ? void 0 : _contactInfo$fields10.customerEmail]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: (ContactLayout_module_default()).contactText,
                children: contactInfo === null || contactInfo === void 0 ? void 0 : (_contactInfo$fields11 = contactInfo.fields) === null || _contactInfo$fields11 === void 0 ? void 0 : _contactInfo$fields11.emailForCustomers
              })]
            })
          })]
        })]
      }), (contactInfo === null || contactInfo === void 0 ? void 0 : (_contactInfo$fields12 = contactInfo.fields) === null || _contactInfo$fields12 === void 0 ? void 0 : _contactInfo$fields12.googlemapquery) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ContactLayout_module_default()).mapContainer,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
          title: "map",
          width: "100%",
          height: "100%",
          src: "//www.google.com/maps/embed/v1/place?key=".concat(googleAPIKey/* default */.Z, "&q=").concat(contactInfo === null || contactInfo === void 0 ? void 0 : (_contactInfo$fields13 = contactInfo.fields) === null || _contactInfo$fields13 === void 0 ? void 0 : _contactInfo$fields13.googlemapquery)
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: (ContactLayout_module_default()).formContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(EmailForm/* default */.Z, {})
    })]
  });
}
// EXTERNAL MODULE: ./src/components/Footer/Footer.jsx + 5 modules
var Footer = __webpack_require__(31875);
// EXTERNAL MODULE: ./src/components/Header/Header.jsx + 8 modules
var Header = __webpack_require__(3266);
// EXTERNAL MODULE: ./src/components/Navigation/Navigation.jsx
var Navigation = __webpack_require__(86894);
;// CONCATENATED MODULE: ./src/pages/contact-us.jsx










function ContactUs(_ref) {
  var footerLinks = _ref.footerLinks,
      navigation = _ref.navigation,
      contact = _ref.contact;
  var contactInfo = contact === null || contact === void 0 ? void 0 : contact[0];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CustomHead/* default */.Z, {
      title: contactInfo === null || contactInfo === void 0 ? void 0 : contactInfo.title
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
      className: (index_module_default()).headerContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {
        navigation: navigation
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Navigation/* default */.Z, {
        navigation: navigation
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactLayout, {
      contactInfo: contactInfo
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {
      footerLinks: footerLinks
    })]
  });
}

var __N_SSG = true;
/* harmony default export */ var contact_us = (ContactUs);

/***/ }),

/***/ 21694:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var GOOGLE_API_KEY = 'AIzaSyDpHdNA79ZQFvlwDYBeoHgT_AFsvIux3JE';
/* harmony default export */ __webpack_exports__["Z"] = (GOOGLE_API_KEY);

/***/ }),

/***/ 84407:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us",
      function () {
        return __webpack_require__(84028);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 23592:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ContactLayout_container__itM6U","mapContainer":"ContactLayout_mapContainer__9jHtE","contactContainer":"ContactLayout_contactContainer__pFNzv","heading":"ContactLayout_heading__WLshg","row":"ContactLayout_row__zxKWh","rowContent":"ContactLayout_rowContent__hjjsd","rowContentColumn":"ContactLayout_rowContentColumn___GrZb","contactTitle":"ContactLayout_contactTitle__BVddC","icon":"ContactLayout_icon__5rRGg","iconAddress":"ContactLayout_iconAddress__I4rSu","contactText":"ContactLayout_contactText__7p3xk","textContainer":"ContactLayout_textContainer__9Cw2l","formContainer":"ContactLayout_formContainer__zdtc6"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5937,9866,1228,4617,5445,3609,3253,3996,4843,9174,5397,5738,9950,851,9774,2888,179], function() { return __webpack_exec__(84407); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);